import { render, staticRenderFns } from "./PosDiscountOptom.vue?vue&type=template&id=ee512462&scoped=true&"
import script from "./PosDiscountOptom.vue?vue&type=script&lang=js&"
export * from "./PosDiscountOptom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee512462",
  null
  
)

export default component.exports